"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.analyticsTrackEvent = analyticsTrackEvent;
function analyticsTrackEvent(name) {
  if (!window._mtm) {
    // console.log('Matomo: Not available');
    return;
  }
  // console.log('Matomo: Event ' + name);
  window._mtm.push({
    event: name
  });
}